export const organizationDetailsKeys = {
  all: ['tenant-organization-details'] as const,
  lists: () => [...organizationDetailsKeys.all, 'list'] as const,
  list: () => [...organizationDetailsKeys.lists()] as const,
};
